import { Grid, IconButton } from '@material-ui/core'
import { withStyles } from '@material-ui/core/styles'
import PropTypes from 'prop-types'
import React from 'react'
import { BiReset, BiRotateLeft, BiRotateRight } from 'react-icons/bi'

const styles = theme => ({
  ul: {
    padding: 2,
    display: 'none'
  },
  li: {
    margin: 12,
    fontSize: 12,
    float: 'left'
  },

  wp: {
    fontSize: '.82em',
    margin: '2px 8px 2px 8px',
    padding: 2
  },
  patientNm: {
    fontSize: '.92em',
    margin: '2px 8px 2px 8px',
    padding: 2
  },
  /* img stuff */
  imgHolder: {
    overflow: 'auto',
    display: 'flex',
    flexDirection: 'column',
    flexWrap: 'wrap',
    alignItems: 'center',
    border: '1px dashed #dcdcce',
    marginTop: 6,
    marginBottom: 6,
    paddingTop: 6,
    paddingBottom: 6
  },

  rotHolder: {
    border: '1px solid #dcdcce',
    backgroundColor: '#f0ffff',
    padding: 3
  },
  rot0: { transform: 'rotate(0deg)' },
  rot1: { transform: 'rotate(90deg)' },
  rot2: { transform: 'rotate(180deg)' },
  rot3: { transform: 'rotate(270deg)' },

  fill: { objectFit: 'fill' },
  contain: {
    //objectFit: 'contain',
    //width: '95%',
    border: '1px solid #9c27b0'
  },
  topInfo: {
    //border: '1px solid #9c27b0',
    paddingLeft: 0
  },
  bottomInfo: {
    //border: '1px solid #9c27b0',
    paddingLeft: 0
  },
  pageNum: {
    float: 'right',
    color: 'gray',
    fontSize: 11,
    fontWeight: 500
  }
})

class ImgHolder extends React.Component {
  constructor(props) {
    super(props)
    this.state = { 
      dims: null,
      rotationPref: this.props.page['rotation-pref'] || 0
    }
  }

  getNaturalDims() {
    this.rawImg = new Image()
    this.rawImg.onload = () => {
      this.setState({
        dims: {
          w: this.rawImg.width,
          h: this.rawImg.height,
          ratio: this.rawImg.width / this.rawImg.height
        }
      })
    }
    this.rawImg.src = this.props.page.imgSrc
  }

  stretchHeight(w) {
    //assumes width got streched, reverse the ratio , keeping w the same
    let cush = 0.25
    let ratio_reversed = 1 / this.state.dims.ratio
    let stretchedHeight = Math.floor((w / ratio_reversed) * (1 - cush))
    return stretchedHeight
  }

  normalizeRotation(rotation) {
    // Normalize rotation to be between 0-3
    while (rotation < 0) rotation += 4
    while (rotation > 3) rotation -= 4
    return rotation
  }

  handleRotation = (value, setMode = true) => {
    const newRotation = setMode 
      ? value 
      : this.normalizeRotation(this.state.rotationPref + value)
    
    this.setState({ rotationPref: this.normalizeRotation(newRotation) })
  }

  render() {
    if (!this.state.dims) {
      this.getNaturalDims()
      return <div>...</div>
    }

    const { classes } = this.props

    let page = this.props.page

    let imgHolderStyle = {
      width: Math.floor(0.95 * this.props.width) //parent widht from ContainerDimensions
    }

    let rotHolderStyle = {
      width: imgHolderStyle.width - 12
    }

    let imgStyle = {
      width: imgHolderStyle.width - 24
    }

    if (this.state.rotationPref === 1 || this.state.rotationPref === 3) {
      rotHolderStyle = { height: imgHolderStyle.width - 12 }
      imgStyle = {
        height: imgHolderStyle.width - 24,
        width: imgHolderStyle.width - 24
      }
    } else {
      if (this.state.dims.ratio > 1) {
        imgStyle.height = this.stretchHeight(imgStyle.width)
      }
    }
    let topInfoStyle = { width: imgHolderStyle.width - 12 }

    return (
      <div style={imgHolderStyle} className={classes.imgHolder}>
        <div style={topInfoStyle} className={classes.topInfo}>
          <Grid container spacing={8} style={{ width: '100%', margin: 0 }}>
            <Grid item xs={9}>
              <ul className={classes.ul}>
                <li className={classes.li}>Parent width: {this.props.width}</li>
                <li className={classes.li}>
                  imgHolder width: {imgHolderStyle.width}
                </li>
                <li className={classes.li}>
                  rotHolder width: {rotHolderStyle.width}
                  Pref:{this.state.rotationPref}
                </li>
                <li className={classes.li}>img width: {imgStyle.width}</li>
                <li className={classes.li}>
                  orig: {this.state.dims.w} X {this.state.dims.h}
                  ratio: {this.state.dims.ratio.toFixed(2)}
                </li>
              </ul>
            </Grid>
            <Grid item xs={3} style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end', minWidth: 0, flexShrink: 0 }}>
              <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end', gap: '4px', marginBottom: '4px' }}>
                <IconButton
                  title="Rotate left"
                  style={{ padding: 2 }}
                  onClick={() => this.handleRotation(-1, false)}>
                  <BiRotateLeft
                    style={{ height: 16, width: 16, color: '#9c27b0' }}
                  />
                </IconButton>
                <IconButton
                  title="Reset rotation"
                  style={{ padding: 2 }}
                  onClick={() => this.handleRotation(0, true)}>
                  <BiReset style={{ height: 14, width: 14, color: '#9c27b0' }} />
                </IconButton>
                <IconButton
                  title="Rotate right"
                  style={{ padding: 2 }}
                  onClick={() => this.handleRotation(1, false)}>
                  <BiRotateRight
                    style={{ height: 16, width: 16, color: '#9c27b0' }}
                  />
                </IconButton>
              </div>
              <div className={classes.pageNum} style={{ textAlign: 'right', width: '100%' }}>
                Top of Page {this.props.pageIdx + 1} of {this.props.pageCount}
              </div>
            </Grid>
          </Grid>
        </div>
        <div
          style={rotHolderStyle}
          className={[
            classes.rotHolder,
            classes['rot' + this.state.rotationPref]
          ].join(' ')}>
          <img alt="pageImg" style={imgStyle} src={page.imgSrc} />
        </div>
        <div style={topInfoStyle} className={classes.bottomInfo}>
          <Grid container spacing={8} style={{ width: '100%', margin: 0 }}>
            <Grid item xs={9} />
            <Grid item xs={3} style={{ display: 'flex', justifyContent: 'flex-end', minWidth: 0, flexShrink: 0 }}>
              <div className={classes.pageNum} style={{ textAlign: 'right' }}>
                Bottom of Page {this.props.pageIdx + 1} of{' '}
                {this.props.pageCount}
              </div>
            </Grid>
          </Grid>
        </div>
      </div>
    )
  }
}

ImgHolder.propTypes = {
  classes: PropTypes.object.isRequired
}

export default withStyles(styles)(ImgHolder)
